const keyboardDatePickerModalFilterExpiredServices = {
  from: 'From',
  to: 'To'
};

export default keyboardDatePickerModalFilterExpiredServices;
